module.exports = __webpack_public_path__ + "fc58576f627677dd7ac7128cd98e995c.jpg";